import styled from 'styled-components';
// Adds backwards compatibility for dependants still at "v1"
// We cannot remove this @ts-expect-error since we use v2 which has types
// but depednent apps still use v1 which don't inlude types so removing this @ts-expect-error will break downstream builds
// @ts-expect-error Library not migrated yet Not safe to remove - JZ
import * as ReactTransitionGroup from 'react-transition-group';
import UIIcon from 'UIComponents/icon/UIIcon';
import { AIIconContainer } from '../../icons/AIIconContainers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  TransitionGroup,
  CSSTransition,
  // @ts-expect-error Library not migrated yet
  CSSTransitionGroup
} = ReactTransitionGroup;
const IconSize = '1em';
const IconMargin = '0.5em';
const TransitionLenght = '300ms';

// -leave classes for backwards compatibility with react-transition-group v1
const StyledTransitionContainer = styled.div.withConfig({
  displayName: "ButtonContentWrapper__StyledTransitionContainer",
  componentId: "rqiz9v-0"
})([".ai-icon{display:inline-block;&.ai-icon-enter{opacity:0;width:0;&.ai-icon-enter-active{opacity:1;width:", ";transition:opacity ", ",width ", ",margin-left ", ",margin-right ", ";}}&.ai-icon-exit{opacity:1;width:", ";&.ai-icon-exit-active{opacity:0;width:0;transition:opacity ", ",width ", ",margin-left ", ",margin-right ", ";}}&.ai-icon-leave{opacity:1;width:", ";&.ai-icon-leave-active{opacity:0;width:0;transition:opacity ", ",width ", ",margin-left ", ",margin-right ", ";}}&.left{margin-right:", ";&.ai-icon-enter{margin-right:0;&.ai-icon-enter-active{margin-right:", ";}}&.ai-icon-exit{margin-right:", ";&.ai-icon-exit-active{margin-right:0;}}&.ai-icon-leave{margin-right:", ";&.ai-icon-leave-active{margin-right:0;}}}&.right{margin-left:", ";&.ai-icon-enter{margin-left:0;&.ai-icon-enter-active{margin-left:", ";}}&.ai-icon-exit{margin-left:", ";&.ai-icon-exit-active{margin-left:0;}}&.ai-icon-leave{margin-left:", ";&.ai-icon-leave-active{margin-left:0;}}}}"], IconSize, TransitionLenght, TransitionLenght, TransitionLenght, TransitionLenght, IconSize, TransitionLenght, TransitionLenght, TransitionLenght, TransitionLenght, IconSize, TransitionLenght, TransitionLenght, TransitionLenght, TransitionLenght, IconMargin, IconMargin, IconMargin, IconMargin, IconMargin, IconMargin, IconMargin, IconMargin);
const ButtonContentWrapper = ({
  isLocked = false,
  children
}) => {
  if (!CSSTransition) {
    return /*#__PURE__*/_jsx(StyledTransitionContainer, {
      children: /*#__PURE__*/_jsxs(CSSTransitionGroup, {
        transitionName: "ai-icon",
        transitionEnterTimeout: TransitionLenght,
        transitionLeaveTimeout: TransitionLenght,
        children: [!isLocked && /*#__PURE__*/_jsx("div", {
          className: "ai-icon left",
          children: /*#__PURE__*/_jsx(AIIconContainer, {
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "artificialIntelligence"
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "display-inline-block",
          children: children
        }), isLocked && /*#__PURE__*/_jsx("div", {
          className: "ai-icon right",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "locked"
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(StyledTransitionContainer, {
    children: /*#__PURE__*/_jsxs(TransitionGroup, {
      children: [!isLocked && /*#__PURE__*/_jsx(CSSTransition, {
        classNames: "ai-icon",
        timeout: 300,
        children: /*#__PURE__*/_jsx("div", {
          className: "ai-icon left",
          children: /*#__PURE__*/_jsx(AIIconContainer, {
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "artificialIntelligence"
            })
          })
        })
      }), children, isLocked && /*#__PURE__*/_jsx(CSSTransition, {
        classNames: "ai-icon",
        timeout: 300,
        children: /*#__PURE__*/_jsx("div", {
          className: "ai-icon right",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "locked"
          })
        })
      })]
    })
  });
};
export default ButtonContentWrapper;